export async function publishMulti(data) {
  const res = await fetch("http://localhost/thedaltech/backend/post-to-social.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Network error");
  return res.json();
}
